// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreVendors = (client) => ({
    /**
     * `GET /store/vendors/:id/certifications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListVendorCertifications
     * @source packages/medusa-plugin-product-documents/src/api/store/vendors/[id]/certifications/route.ts
     */
    listCertifications: (id, query, headers) => client.fetch(buildPath("/store/vendors/:id/certifications", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/vendors/:handle`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreVendorsHandleRetrieve
     * @source apps/backend/src/api/store/vendors/[handle]/route.ts
     */
    retrieve: (handle, query, headers) => client.fetch(buildPath("/store/vendors/:handle", [handle]), { method: "GET", query, headers }),
    /**
     * `GET /store/vendors/:id/legal`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreVendorsIdLegalRetrieve
     * @source apps/backend/src/api/store/vendors/[id]/legal/route.ts
     */
    retrieveLegal: (id, query, headers) => client.fetch(buildPath("/store/vendors/:id/legal", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=vendors.js.map